import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { secureLink } from '@sparta.global.helpers/secure-link-helper/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div>\r\n    <h2>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"heading") || (depth0 != null ? lookupProperty(depth0,"heading") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"heading","hash":{},"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":3,"column":19}}}) : helper)))
    + "</h2>\r\n    <div class=\"hide-for-large-up\">\r\n      <p>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"subText") || (depth0 != null ? lookupProperty(depth0,"subText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subText","hash":{},"data":data,"loc":{"start":{"line":5,"column":9},"end":{"line":5,"column":20}}}) : helper)))
    + "</p>\r\n      <span>"
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"telephone") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":6,"column":12},"end":{"line":6,"column":36}}}))
    + "</span>\r\n    </div>\r\n    <div class=\"hide-mobile-tablet\">\r\n      <p>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"subText1") || (depth0 != null ? lookupProperty(depth0,"subText1") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subText1","hash":{},"data":data,"loc":{"start":{"line":9,"column":9},"end":{"line":9,"column":21}}}) : helper)))
    + "</p>\r\n      <p>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"subText2") || (depth0 != null ? lookupProperty(depth0,"subText2") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subText2","hash":{},"data":data,"loc":{"start":{"line":10,"column":9},"end":{"line":10,"column":21}}}) : helper)))
    + "<span>"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"subTextPhone") || (depth0 != null ? lookupProperty(depth0,"subTextPhone") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"subTextPhone","hash":{},"data":data,"loc":{"start":{"line":10,"column":27},"end":{"line":10,"column":43}}}) : helper)))
    + "</span></p>\r\n    </div>\r\n  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"contactHelper") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":13,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.merrill-homepage.modules/contact-helper-module",
  "version": "2.0.0",
  "id": "contactHelperModule",
  "containerID": "merrillHomepageContactHelperModule",
  "moduleName": "merrill-homepage-contact-helper-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "contact-helper-module",
  "data": {
    "init": "ContactHelperModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        secureLink,
        link
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    secureLink,
    link
  },
  "dependencies": {
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.helpers/secure-link-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0"
  },
  "stores": []
};

/**
 * @export
 * @class ContactHelperModule
 * @extends {Module}
 */
class ContactHelperModule extends Module {
  /**
   * Creates an instance of ContactHelperModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof ContactHelperModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @returns {void}
   */
  init() {}
}
registerModuleClass({
  moduleClass: ContactHelperModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ContactHelperModule as default, moduleConfig };
